export default __webpack_public_path__ + "static/1-4925dfb17047ffc1deae69e8474c94cc.jpg";